import { useApiQuery } from 'frontend/js/modules/infra/api';
import { getViewerIdAndKind, useSession } from 'frontend/js/modules/infra/session';
import { endpoints } from '../../../network';
import { getAutomatedTableData } from './utils';
export var useAutomatedCampaigns = function () {
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var _a = useApiQuery({
        endpoint: endpoints.automatedCampaignsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
        },
        options: {
            enabled: !!viewerIdAndKind,
        },
    }), campaigns = _a.data, isLoading = _a.isLoading;
    var tableData = getAutomatedTableData((campaigns === null || campaigns === void 0 ? void 0 : campaigns.data) || []);
    return {
        tableData: tableData,
        isLoading: isLoading,
        count: tableData.length,
    };
};
